const breakPoints = {
  BigDesktops: 1440,
  smallDesktop: 1070,
  table: 768,
  phone: 490,
};

export default breakPoints;